import {NavLink} from 'react-router-dom';
// import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const SidebarItem = ({title, path}) => {
  return (
      <div className={"sidebar-item m-3 text-start"}>
        <NavLink to={`/ui${path}`} className={"sidebar-item-link d-block w-100 p-3 text-center"}>
          <span className={"sidebar-title"}>
            {/*<FontAwesomeIcon icon={icon} className={'pe-2'}/>*/}
            <span className={"sidebar-title-text"}>{title}</span>
          </span>
        </NavLink>
      </div>
  );
};

export default SidebarItem;
